/**
 * Enum for integration and system users with their identifiers
 */
export enum DefaultUser {
  CADENCEPRO = "0",        // Cadence Pro
  CHATBOT = "-1",          // AI
  INTEGRATIONJIRA = "-2",  // Jira Integration
  INTEGRATIONASANA = "-3", // Asana Integration
  INTEGRATIONMONDAY = "-4", // Monday Integration
  INTEGRATIONAZURE = "-5"  // Azure Integration
}

/**
 * Map of default user IDs to their display names
 */
export const defaultUserNames: Record<string, string> = {
  [DefaultUser.CADENCEPRO]: "Cadence Pro",
  [DefaultUser.CHATBOT]: "AI ",
  [DefaultUser.INTEGRATIONJIRA]: "Jira Integration",
  [DefaultUser.INTEGRATIONASANA]: "Asana Integration",
  [DefaultUser.INTEGRATIONMONDAY]: "Monday Integration",
  [DefaultUser.INTEGRATIONAZURE]: "Azure Integration"
};

/**
 * Map of default user IDs to their image URLs
 */
export const defaultUserImages: Record<string, string> = {
  [DefaultUser.CADENCEPRO]: "/candencepro.png",
  [DefaultUser.CHATBOT]: "/candencepro.png",
  [DefaultUser.INTEGRATIONJIRA]: "/candencepro.png",
  [DefaultUser.INTEGRATIONASANA]: "/candencepro.png",
  [DefaultUser.INTEGRATIONMONDAY]: "/candencepro.png",
  [DefaultUser.INTEGRATIONAZURE]: "/candencepro.png"
};

/**
 * Helper function to get a display name for a user ID
 * @param userId The user ID to check
 * @returns The display name if it's a default user, or null if not
 */
export const getDefaultUserName = (userId: string): string | null => {
  if (Object.values(DefaultUser).includes(userId as DefaultUser)) {
    return defaultUserNames[userId];
  }
  return null;
};

/**
 * Helper function to get an image URL for a default user ID
 * @param userId The user ID to check
 * @returns The image URL if it's a default user, or null if not
 */
export const getDefaultUserImage = (userId: string): string | null => {
  if (Object.values(DefaultUser).includes(userId as DefaultUser)) {
    return defaultUserImages[userId] || null;
  }
  return null;
}; 